module.exports = __webpack_public_path__ + "img/IMG_0057_L_WoodMatted_MockedUp.82f22913.jpg";